import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const searchAttributes = [
  // Node.
  'page_title',
  'body',
  'body_summarized',
  'labels_searchable',
  'paragraphs_entity_title',
  'paragraphs_body',
  'media_item_entity_name',
  'media_item_entity_caption',
  'media_item_entity_video_description',
  'media_item_entity_audio_description',
  'image_alt',

  // Article.
  'article_type_searchable',

  // Project.
  'project_types_searchable',
  'project_status_searchable',

  // Taxonomy term.
  'taxonomy_name',
  'taxonomy_description',
  'taxonomy_paragraphs_body',
  'taxonomy_image_alt',

  // Profile.
  'first_name',
  'last_name',
  'profile_description',
  'profile_paragraphs_body',
  'profile_image_alt',
];

export const resultAttributes = [
  // General.
  'url',
  'entity_type',
  'langcode',

  // Node.
  'content_type',
  'nid',
  'page_title',
  'body',
  'body_summarized',
  'link_url',
  'link_text',
  'paragraphs_entity_title',
  'paragraphs_body',
  'publish_date',
  'image_ratio_1_1_xxs',
  'image_ratio_1_1_xs',
  'image_ratio_1_1_sm',
  'image_ratio_1_1_md',
  'image_ratio_3_2_xxs',
  'image_ratio_3_2_xs',
  'image_ratio_3_2_sm',
  'image_ratio_3_2_md',
  'image_ratio_3_4_xxs',
  'image_ratio_3_4_xs',
  'image_ratio_3_4_sm',
  'image_ratio_3_4_md',
  'image_ratio_4_3_xxs',
  'image_ratio_4_3_xs',
  'image_ratio_4_3_sm',
  'image_ratio_4_3_md',
  'image_ratio_16_9_xxs',
  'image_ratio_16_9_xs',
  'image_ratio_16_9_sm',
  'image_ratio_16_9_md',
  'image_alt',

  // Article.
  'article_type_name',

  // Project.
  'project_types_name',
  'project_status_name',

  // Vacancy.
  'vacancy_employment_types',
  'vacancy_function_name',
  'vacancy_locations_name',

  // Taxonomy term.
  'vid',
  'tid',
  'taxonomy_name',
  'taxonomy_description',
  'taxonomy_icon_name',
  'taxonomy_icon_family',
  'taxonomy_label_icon_classes',
  'taxonomy_parent_tid',
  'taxonomy_image_ratio_1_1_xxs',
  'taxonomy_image_ratio_1_1_xs',
  'taxonomy_image_ratio_1_1_sm',
  'taxonomy_image_ratio_1_1_md',
  'taxonomy_image_alt',

  // Profile.
  'profile_type',
  'profile_id',
  'first_name',
  'last_name',
  'profile_description',
  'profile_address',
  'profile_functions_name',
  'profile_locations_name',
  'profile_image_ratio_1_1_xxs',
  'profile_image_ratio_1_1_xs',
  'profile_image_ratio_1_1_sm',
  'profile_image_ratio_1_1_md',
  'profile_image_alt',
];

export const highlightAttributes = [
  // Node.
  'page_title',
  'body',
  'body_summarized',
  'paragraphs_entity_title',
  'paragraphs_body',

  // Taxonomy term.
  'taxonomy_name',
  'taxonomy_description',

  // Profile.
  'first_name',
  'last_name',
  'profile_description',
];

export const facetAttributes: Exclude<SearchkitWrapperProps['searchSettings']['facet_attributes'], undefined> = [
  {
    attribute: 'content_type',
    field: 'content_type',
    type: 'string',
    facetQuery: (field, size) => ({
      terms: {
        field,
        size,
        exclude: ['basic_page', 'overview_page', 'landing_page', 'homepage'],
      },
    }),
  },
  {
    attribute: 'article_type_name',
    field: 'article_type_name',
    type: 'string',
  },
  {
    attribute: 'project_types_name',
    field: 'project_types_name',
    type: 'string',
  },
  {
    attribute: 'project_status_name',
    field: 'project_status_name',
    type: 'string',
  },
  {
    attribute: 'vacancy_employment_types',
    field: 'vacancy_employment_types',
    type: 'string',
  },
  {
    attribute: 'vacancy_function_name',
    field: 'vacancy_function_name',
    type: 'string',
  },
  {
    attribute: 'vacancy_locations_name',
    field: 'vacancy_locations_name',
    type: 'string',
  },
];

export const sorting: Exclude<SearchkitWrapperProps['searchSettings']['sorting'], undefined> = {
  default: [
    // Default sorting by score.
    {
      field: '_score',
      order: 'desc',
    },
    // Articles and vacancies.
    {
      field: 'publish_date',
      order: 'desc',
    },
    // Other nodes.
    {
      field: 'created',
      order: 'desc',
    },
    // Taxonomy terms.
    {
      field: 'taxonomy_weight',
      order: 'asc',
    },
  ],
};
